import cx from 'classnames'
import { Icon } from '@/ui/icon'

type RoundButtonVariant = 'default' | 'contrast' | 'confirm' | 'destructive'

interface RoundButtonProps {
  icon: string
  label?: string
  variant?: RoundButtonVariant
  className?: string
  onClick?: () => void
  disabled?: boolean
}

const RoundButton = ({
  icon,
  label,
  variant = 'default',
  className,
  onClick,
  disabled,
}: RoundButtonProps) => {
  return (
    <button
      className={cx('round-button', variant, className)}
      onClick={onClick}
      disabled={disabled}
    >
      {label && <span className="sr-only">{label}</span>}
      <Icon size={16} name={icon} />
    </button>
  )
}

export default RoundButton
